import React from 'react';  // eslint-disable-line

const Trash = () => {
    return (
        <svg width="12px" height="15px" viewBox="0 0 12 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Admin-CMS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="custom-pages-list-20" transform="translate(-928.000000, -413.000000)">
                    <g id="Icon-/-Delete-Copy-8" transform="translate(926.000000, 412.000000)">
                        <polygon id="Shape" points="16 0 16 16 0 16 0 0" />
                        <path d="M13.571429,2.20834233 L10.3571432,2.20834233 L10.1053575,1.69701455 C9.99656536,1.47403811 9.77348433,1.33316426 9.52946458,1.3333381 L6.46785732,1.3333381 C6.22429652,1.33238712 6.00163625,1.4736523 5.89464301,1.69701455 L5.64285729,2.20834233 L2.42857145,2.20834233 C2.19187797,2.20834233 2,2.40421761 2,2.64584203 L2,3.52084143 C2,3.76246584 2.19187797,3.95834113 2.42857145,3.95834113 L13.571429,3.95834113 C13.8081225,3.95834113 14,3.76246584 14,3.52084143 L14,2.64584203 C14,2.40421761 13.8081225,2.20834233 13.571429,2.20834233 Z M3.42500006,14.1028654 C3.46742596,14.7944666 4.02922136,15.3333405 4.70803582,15.3333405 L11.2919647,15.3333405 C11.9707791,15.3333405 12.5325745,14.7944666 12.5750004,14.1028654 L13.1428576,4.83334053 L2.85714289,4.83334053 L3.42500006,14.1028654 Z" id="Shape" fill="#616B7D" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Trash;
